export type SortDirection = 'asc' | 'desc';

export interface SortConfig {
    key: string;
    direction: SortDirection;
}

const getNestedValue = (obj: any, path: string): any => {
    return path.split('.').reduce((current, prop) => current?.[prop], obj);
};

export function sortScripts(data: any[], config: SortConfig): any[] {
    if (!config.key) return data;

    const normalize = (value: string) =>
        value
            ?.toString()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();

    const normalizeMixed = (value: string): string => {
        return value
            ?.toString()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '') // remove accents
            .replace(/[^a-zA-Z0-9]/g, ' ')   // remove punctuation
            .toLowerCase()
            .trim();
    };

    const isDateField = config.key.toLowerCase().includes("date");
    const isMixedField = config.key === 'Additional Info';

    return [...data].sort((a, b) => {
        const aRaw = getNestedValue(a, config.key) || '';
        const bRaw = getNestedValue(b, config.key) || '';

        if (isDateField) {
            const aDate = aRaw ? new Date(aRaw) : null;
            const bDate = bRaw ? new Date(bRaw) : null;

            const aValid = aDate instanceof Date && !isNaN(aDate.getTime());
            const bValid = bDate instanceof Date && !isNaN(bDate.getTime());

            if (!aValid && !bValid) return 0;
            if (!aValid) return 1;
            if (!bValid) return -1;

            const diff = aDate.getTime() - bDate.getTime();
            return config.direction === 'asc' ? diff : -diff;
        }

        if (isMixedField) {
            const aVal = normalizeMixed(aRaw);
            const bVal = normalizeMixed(bRaw);
            return config.direction === 'asc'
                ? aVal.localeCompare(bVal)
                : bVal.localeCompare(aVal);
        }

        const aVal = normalize(aRaw);
        const bVal = normalize(bRaw);
        return config.direction === 'asc'
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
    });
}
